import React from 'react';
import { createRoot } from 'react-dom/client';
import ReactGA from 'react-ga4';
import App from './App';

ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID || '');

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);
